<template>
  <el-card
    shadow="always"
    :body-style="{ padding: '20px' }"
    v-loading="loading || balanceAPILoading || groupsLoading"
  >
    <div slot="header">
      <el-row :gutter="20">
        <el-col :span="16" :offset="0">
          <div v-if="balanceAccountGroups && balanceAccountGroups.docs">
            <el-radio-group
              v-model="groupSelectedLocal"
              size="mini"
              v-loading="groupsLoading || loading"
            >
              <el-radio-button :key="null" :label="null">Все</el-radio-button>
              <el-radio-button
                v-for="group in balanceAccountGroups.docs"
                :key="group._id"
                :label="group._id"
                >{{ group.name }}</el-radio-button
              >
            </el-radio-group>
          </div>
          <div v-else>
            <el-skeleton :rows="1" animated />
          </div>
        </el-col>
        <el-col :span="8" :offset="0">
          <div>
            <el-button
              size="mini"
              @click="getCsv"
              :loading="csvLoading"
              icon="el-icon-download"
              >CSV</el-button
            >
            <el-button
              v-if="
                balanceAccounts &&
                  balanceAccounts.docs &&
                  balanceAccounts.docs.length === 0 &&
                  groupSelected !== null
              "
              size="mini"
              @click="handleDeleteSelectedGroup"
              :loading="groupsLoading"
              type="danger"
              icon="el-icon-delete"
              >Удалить текущую группу</el-button
            >
          </div>
        </el-col>
      </el-row>
      <div v-if="verificationSummary" class="verification-summary">
        <span v-if="verificationSummary.inconsistentCount > 0" class="verification-summary__bad">
          <i class="el-icon-warning"></i>
          Счетов с расхождением: {{ verificationSummary.inconsistentCount }}
        </span>
        <span v-else class="verification-summary__ok">
          <i class="el-icon-success"></i>
          Расхождений не найдено
        </span>
        <span v-if="verificationSummary.lastVerifiedAt" class="verification-summary__meta">
          — последняя фоновая проверка:
          {{ $dayjs(verificationSummary.lastVerifiedAt).format("DD.MM.YYYY HH:mm") }}
        </span>
      </div>
    </div>
    <div v-if="balanceAccounts && balanceAccounts.docs">
      <el-table
        :data="balanceAccounts.docs"
        @sort-change="handleSortChange"
        :default-sort="{ prop: '_id', order: 'descending' }"
        :row-class-name="tableRowClassName"
        border
        stripe
      >
        <el-table-column sortable="custom" prop="_id" label="ID" width="90">
          <template v-slot="scope">
            <i v-if="scope.row.isNew" class="el-icon-document-add"></i>
            {{ scope.row._id.slice(-6) }}
          </template>
        </el-table-column>
        <el-table-column
          sortable="custom"
          prop="title"
          label="Название"
          min-width="150"
        >
          <template v-slot="scope">
            <el-row :gutter="20">
              <el-col :span="16" :offset="0">
                {{ scope.row.title }}
              </el-col>
              <el-col :span="8" :offset="0">
                <div style="float: right;">
                  <el-button
                    size="mini"
                    icon="el-icon-edit"
                    circle
                    @click="handleEditBalanceTitle(scope.row)"
                  ></el-button>
                </div>
              </el-col>
            </el-row>
          </template>
        </el-table-column>
        <el-table-column
          sortable="custom"
          prop="balance"
          label="Баланс"
          width="150"
        >
        </el-table-column>
        <el-table-column
          sortable="custom"
          prop="balanceInRub"
          label="Баланс в RUB"
          width="150"
        >
        </el-table-column>
        <el-table-column
          sortable="custom"
          prop="verifiedStatusRank"
          label="Целостность"
          width="110"
        >
          <template v-slot="scope">
            <el-tooltip
              placement="top"
              v-if="scope.row.lastVerifiedAt && scope.row.verifiedHasData"
            >
              <div slot="content">
                Проверено: {{ $dayjs(scope.row.lastVerifiedAt).format("DD.MM.YYYY HH:mm") }}<br />
                Расчётный баланс: {{ scope.row.verifiedComputedBalance }}<br />
                Разница: {{ scope.row.verifiedDelta }}<br />
                Внутренних разрывов в истории: {{ scope.row.verifiedBreaksCount }}
              </div>
              <router-link
                :to="{ name: 'BalanceFull', params: { id: scope.row._id } }"
              >
                <i
                  :class="
                    scope.row.verifiedIsConsistent
                      ? 'el-icon-success'
                      : 'el-icon-warning'
                  "
                  :style="{
                    color: scope.row.verifiedIsConsistent
                      ? 'rgb(100,200,28)'
                      : 'red',
                    fontSize: '18px'
                  }"
                ></i>
              </router-link>
            </el-tooltip>
            <el-tooltip placement="top" v-else-if="scope.row.lastVerifiedAt">
              <div slot="content">
                Проверено: {{ $dayjs(scope.row.lastVerifiedAt).format("DD.MM.YYYY HH:mm") }}<br />
                Нет ни одной проводки с записанным балансом после (либо истории
                нет вовсе, либо она вся легаси) — сравнивать не с чем,
                целостность не оценивается
              </div>
              <router-link
                :to="{ name: 'BalanceFull', params: { id: scope.row._id } }"
              >
                <i
                  class="el-icon-info"
                  style="color: #909399; font-size: 18px;"
                ></i>
              </router-link>
            </el-tooltip>
            <span v-else style="color: #909399;">—</span>
          </template>
        </el-table-column>
        <el-table-column sortable="custom" prop="type" label="Счет" width="100">
          <template v-slot="scope">
            <i v-if="scope.row.credential" class="el-icon-key"></i>
            {{ balanceTypes.find(t => t.type === scope.row.type)["title"] }}
          </template>
        </el-table-column>
        <el-table-column
          sortable="custom"
          prop="valute"
          label="Валюта"
          width="100"
        >
          <template v-slot="scope">
            {{ scope.row.valute && scope.row.valute.name }}
          </template>
        </el-table-column>
        <el-table-column
          sortable="custom"
          prop="is_used_for_auto_exchange"
          label="Автообмен"
          width="90"
        >
          <template v-slot="scope">
            <el-popconfirm
              title="Изменить значение использования для автообмена?"
              @confirm="
                handleUseForAutoExchangeSwitch(scope.row, {
                  is_used_for_auto_exchange: !scope.row
                    .is_used_for_auto_exchange
                })
              "
            >
              <el-switch
                :value="scope.row.is_used_for_auto_exchange"
                slot="reference"
              >
              </el-switch>
            </el-popconfirm>
          </template>
        </el-table-column>
        <el-table-column prop="group" label="Группа" width="220">
          <template v-slot="scope">
            <div v-if="balanceAccountGroups && balanceAccountGroups.docs">
              <balanceAccountGroupChanger :balance="scope.row" />
            </div>
          </template>
        </el-table-column>
        <el-table-column label="Действия" width="150">
          <template v-slot="scope">
            <el-tooltip placement="top" v-if="session.type <= -1">
              <div slot="content">Удалить баланс</div>
              <el-button
                size="small"
                icon="el-icon-delete"
                @click="handleDeleteBalance(scope.row._id)"
              ></el-button>
            </el-tooltip>
            <el-tooltip placement="top">
              <div slot="content">Просмотреть полную историю</div>
              <el-button
                size="small"
                icon="el-icon-s-order"
                @click="
                  $router.push({
                    name: 'BalanceFull',
                    params: { id: scope.row._id }
                  })
                "
              ></el-button>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @current-change="handleBAPage"
        @size-change="handleLimit"
        :current-page.sync="balanceAccounts.page"
        :page-size="balanceAccounts.limit"
        layout="sizes, prev, pager, next, jumper"
        :page-sizes="[5, 10, 30, 50, 100, 200]"
        :total="balanceAccounts.totalDocs"
      >
      </el-pagination>
    </div>
    <el-collapse v-if="session.type <= -1">
      <el-collapse-item name="1">
        <template slot="title">
          <i class="header-icon el-icon-plus"></i>
          Добавить баланс
        </template>
        <el-form
          :model="newBA"
          ref="form"
          label-width="180px"
          :inline="false"
          size="normal"
        >
          <el-form-item label="Счет">
            <el-select v-model="newBA.type" filterable>
              <el-option
                v-for="item in balanceTypes"
                :key="item.type"
                :label="item.title"
                :value="item.type"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="Валюта">
            <el-select
              v-model="newBA.valuteId"
              filterable
              :loading="!valutes.length"
            >
              <el-option
                v-for="item in valutesOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item
            v-if="
              [
                'bitzlato',
                'whitebit',
                'firekassa',
                'vanilapay',
                'okx'
              ].includes(newBA.type)
            "
            label="Ключи"
          >
            <el-select
              v-model="newBA.credentialId"
              filterable
              clearable
              :loading="!credentials.length"
            >
              <el-option
                v-for="item in credentialsOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
            <div>
              Если выбрать ключи доступа к API, то этот баланс будет обновляться
              автоматически
            </div>
          </el-form-item>

          <el-form-item label="Название">
            <el-input v-model="newBA.title"></el-input>
          </el-form-item>
          <el-form-item label="Баланс">
            <el-input
              style="width: 360px;"
              v-model="newBA.balance"
              @change="handleBalanceChange"
            >
            </el-input>
            <el-button
              v-if="
                newBA.credentialId &&
                  newBA.valuteId &&
                  newBA.type === 'bitzlato'
              "
              type="primary"
              @click="checkBZBalance"
              >Получить баланс по API Bitzlato</el-button
            >
            <el-button
              v-if="
                newBA.credentialId &&
                  newBA.valuteId &&
                  newBA.type === 'whitebit'
              "
              type="primary"
              @click="checkWBBalance"
              >Получить баланс по API Whitebit</el-button
            >
            <el-button
              v-if="
                newBA.credentialId && newBA.valuteId && newBA.type === 'okx'
              "
              type="primary"
              @click="checkOKXBalance"
              >Получить баланс по API OKX</el-button
            >
            <el-button
              v-if="
                newBA.credentialId &&
                  newBA.valuteId &&
                  newBA.type === 'firekassa'
              "
              type="primary"
              @click="checkFKBalance"
              >Получить баланс по API Firekassa</el-button
            >
            <el-button
              v-if="
                newBA.credentialId &&
                  newBA.valuteId &&
                  newBA.type === 'vanilapay'
              "
              type="primary"
              @click="checkVPBalance"
              >Получить баланс по API Vanilapay</el-button
            >
          </el-form-item>
          <el-form-item label="Использовать для автообмена">
            <el-switch v-model="newBA.is_used_for_auto_exchange"></el-switch>
          </el-form-item>
          <el-form-item
            label="Группа"
            v-if="balanceAccountGroups && balanceAccountGroups.docs"
          >
            <el-select
              v-model="newBA.group"
              value-key="name"
              filterable
              clearable
              allow-create
              default-first-option
              placeholder="Выберите или создайте группу"
              :loading="groupsLoading"
            >
              <el-option
                v-for="item in balanceAccountGroups.docs.map(g => g.name)"
                :key="item"
                :label="item"
                :value="item"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="addBA">Добавить</el-button>
            <el-button @click="resetNewBA">Очистить</el-button>
          </el-form-item>
        </el-form>
      </el-collapse-item>
    </el-collapse>
  </el-card>
</template>
<script>
import { mapState, mapActions } from "vuex";
import { getBalanceAccountsCsv } from "@/api";

import {
  getLedgerTransactions,
  getLedgerValutes,
  getCredentials,
  getBitzlatoWallet,
  getWhitebitWallet,
  getFirekassaWallet,
  getVanilapayWallet,
  getOkxWallet
} from "@/api";
import balanceTypes from "./balanceTypes";
import balanceAccountGroupChanger from "./groupChanger.vue";
export default {
  name: "LedgerBalancesComponent",
  components: { balanceAccountGroupChanger },
  data: () => ({
    balanceTypes,
    balanceAPILoading: false,
    newBA: {
      valuteId: null,
      credentialId: null,
      title: "",
      balance: "",
      type: "operator",
      is_used_for_auto_exchange: false,
      group: null
    },
    ledgerValutes: [],
    credentials: [],
    csvLoading: false
  }),
  computed: {
    ...mapState("balanceAccounts", [
      "balanceAccounts",
      "verificationSummary",
      "loading",
      "balanceAccountGroups",
      "groupsLoading",
      "groupSelected"
    ]),
    ...mapState("valutes", ["valutes"]),
    ...mapState("auth", ["session"]),
    groupSelectedLocal: {
      get() {
        return this.groupSelected;
      },
      set(groupSelected) {
        this.changeGroupSelected({ groupSelected });
      }
    },
    valutesOptions() {
      return this.ledgerValutes.map(valute => {
        return {
          value: valute._id,
          label: valute.name
        };
      });
    },
    credentialsOptions() {
      return this.credentials
        .filter(cred => cred.type === this.newBA.type)
        .map(cred => {
          return {
            value: cred._id,
            label: cred.title
          };
        });
    },
    newBAType() {
      return this.newBA.type;
    }
  },
  watch: {
    newBAType() {
      this.newBA.credentialId = null;
    }
  },
  methods: {
    ...mapActions("balanceAccounts", [
      "getBalanceAccounts",
      "getBalanceAccountGroups",
      "editBalanceAccountGroup",
      "goToPage",
      "changeLimit",
      "changeSorting",
      "changeGroupSelected",
      "addBalanceAccount",
      "editUsedForAutoExchangeBalanceAccount",
      "deleteBalanceAccount",
      "editBalanceAccount",
      "deleteBalanceAccountGroup"
    ]),
    ...mapActions("valutes", ["getValutes", "getSortedValutes"]),
    async getCsv() {
      try {
        this.csvLoading = true;
        const { data } = await getBalanceAccountsCsv({
          pagination: false,
          query: { is_deposit: false }
        });
        const fileURL = window.URL.createObjectURL(new Blob([data]));
        const fileLink = document.createElement("a");

        fileLink.href = fileURL;
        fileLink.setAttribute(
          "download",
          `balances_${this.$dayjs().format("DD_MM_YYYY_HH_mm_ss")}.csv`
        );
        document.body.appendChild(fileLink);

        fileLink.click();
      } catch (error) {
        this.handleResponseError(error);
      } finally {
        this.csvLoading = false;
      }
    },
    async checkBZBalance() {
      try {
        this.balanceAPILoading = true;
        const { data } = await getBitzlatoWallet({
          currencyId: this.newBA.valuteId,
          credentialId: this.newBA.credentialId
        });
        this.$message({
          type: "success",
          message: `Баланс успешно получен, значение подставлено в поле "Баланс"`
        });
        this.newBA.balance = data.result;
        this.balanceAPILoading = false;
      } catch (error) {
        this.balanceAPILoading = false;
        console.log(error);
        this.handleResponseError(error);
      }
    },
    async checkWBBalance() {
      try {
        this.balanceAPILoading = true;
        const { data } = await getWhitebitWallet({
          currencyId: this.newBA.valuteId,
          credentialId: this.newBA.credentialId
        });
        this.$message({
          type: "success",
          message: `Баланс успешно получен, значение подставлено в поле "Баланс"`
        });
        this.newBA.balance = data.result;
        this.balanceAPILoading = false;
      } catch (error) {
        this.balanceAPILoading = false;
        console.log(error);
        this.handleResponseError(error);
      }
    },
    async checkOKXBalance() {
      try {
        this.balanceAPILoading = true;
        const { data } = await getOkxWallet({
          currencyId: this.newBA.valuteId,
          credentialId: this.newBA.credentialId
        });
        this.$message({
          type: "success",
          message: `Баланс успешно получен, значение подставлено в поле "Баланс"`
        });
        this.newBA.balance = data.result;
        this.balanceAPILoading = false;
      } catch (error) {
        this.balanceAPILoading = false;
        console.log(error);
        this.handleResponseError(error);
      }
    },
    async checkFKBalance() {
      try {
        this.balanceAPILoading = true;
        const { data } = await getFirekassaWallet({
          currencyId: this.newBA.valuteId,
          credentialId: this.newBA.credentialId
        });
        this.$message({
          type: "success",
          message: `Баланс успешно получен, значение подставлено в поле "Баланс"`
        });
        this.newBA.balance = data.result;
        this.balanceAPILoading = false;
      } catch (error) {
        this.balanceAPILoading = false;
        console.log(error);
        this.handleResponseError(error);
      }
    },
    async checkVPBalance() {
      try {
        this.balanceAPILoading = true;
        const { data } = await getVanilapayWallet({
          currencyId: this.newBA.valuteId,
          credentialId: this.newBA.credentialId
        });
        this.$message({
          type: "success",
          message: `Баланс успешно получен, значение подставлено в поле "Баланс"`
        });
        this.newBA.balance = data.result;
        this.balanceAPILoading = false;
      } catch (error) {
        this.balanceAPILoading = false;
        console.log(error);
        this.handleResponseError(error);
      }
    },
    tableRowClassName({ row, rowIndex }) {
      if (row.isNew) {
        return "new-row";
      }
      return "";
    },
    async handleDeleteBalance(id) {
      const linkedTransactions = await getLedgerTransactions({
        pagination: false,
        query: { balanceAccount: id }
      });
      console.log(linkedTransactions);
      let message = "Вы точно хотите удалить баланс?";
      if (
        linkedTransactions.data.status &&
        linkedTransactions.data.result.totalDocs
      )
        message += " У баланса есть связанные транзакции!";

      try {
        await this.$confirm(message, "Внимание!", {
          confirmButtonText: "Удалить",
          cancelButtonText: "Отменить",
          type: "warning"
        });
        await this.deleteBalanceAccount(id);
        await this.getBalanceAccounts();
        await this.getBalanceAccountGroups();
        this.$message({
          type: "success",
          message: `Баланс успешно удален`
        });
      } catch (error) {
        this.$message({
          type: "info",
          message: "Удаление отменено"
        });
      }
    },
    async handleEditBalanceTitle(balance) {
      try {
        const message = `Введите новое название:`;
        const { value } = await this.$prompt(message, `Баланс ${balance._id}`, {
          confirmButtonText: "Сохранить",
          cancelButtonText: "Отменить",
          inputPlaceholder: `${balance.title}`,
          inputValue: `${balance.title}`,
          inputValidator: val => {
            if (val.length > 150)
              return "Название должно быть короче 150 символов";
            return true;
          }
        });
        await this.editBalanceAccount({
          id: balance._id,
          data: { title: value }
        });
        await this.getBalanceAccounts();
        await this.getBalanceAccountGroups();
        this.$message({
          type: "success",
          message: `Название баланса успешно изменено на ${value}`
        });
      } catch (error) {
        if (["close", "cancel"].includes(error)) return;
        console.log(error);
        return this.handleResponseError(error);
      }
    },
    async handleSortChange(sortData) {
      const sort =
        sortData.order === "ascending"
          ? sortData.prop
          : sortData.order === "descending"
          ? `-${sortData.prop}`
          : "";
      await this.changeSorting({ sort });
    },
    handleBAPage(page) {
      this.goToPage({ page });
    },
    handleLimit(limit) {
      this.changeLimit({ limit });
    },
    async handleUseForAutoExchangeSwitch(balanceAccount, editedColumns) {
      try {
        let editBalanceAccount = {
          ...balanceAccount,
          ...editedColumns
        };
        await this.editUsedForAutoExchangeBalanceAccount({
          id: editBalanceAccount._id,
          balanceAccount: editBalanceAccount
        });
        await this.getBalanceAccounts();
        await this.getBalanceAccountGroups();
        this.$message.success("Операция прошла успешно");
      } catch (error) {
        this.handleResponseError(error);
      }
      //
    },
    handleBalanceChange(val) {
      const parsedVal = parseFloat(parseFloat(val).toFixed(12));
      this.newBA.balance = parsedVal;
    },
    async handleDeleteSelectedGroup() {
      if (this.groupSelected === null) return;
      try {
        await this.deleteBalanceAccountGroup(this.groupSelected);
        await this.getBalanceAccounts();
        await this.getBalanceAccountGroups();
        this.groupSelectedLocal = null;
      } catch (error) {
        this.handleResponseError(error);
      }
    },
    resetNewBA() {
      this.newBA = {
        valuteId: null,
        credentialId: null,
        title: "",
        balance: "",
        type: "operator"
      };
    },
    async addBA() {
      try {
        const balance = ("" + this.newBA.balance).replace(",", ".");
        const data = {
          ...this.newBA,
          balance
        };
        const resp = await this.addBalanceAccount(data);
        await this.getBalanceAccounts();
        await this.getBalanceAccountGroups();
        // console.log(resp);
        this.resetNewBA();
        return this.$notify.success({
          title: "Успех",
          message: `Счет баланса ${resp.data.result.title || ""} создан!`
        });
      } catch (error) {
        console.log(error);
        this.handleResponseError(error);
      }
    },
    async getAllData() {
      try {
        const valutesResp = await getLedgerValutes({ pagination: false });
        if (valutesResp.data.status)
          this.ledgerValutes = valutesResp.data.result.docs;
        const credentialResp = await getCredentials({ pagination: false });
        if (credentialResp.data.status)
          this.credentials = credentialResp.data.result.docs;
        await this.getBalanceAccountGroups();
        await this.getBalanceAccounts();
      } catch (error) {
        this.handleResponseError(error);
      }
    }
  },
  async mounted() {
    await this.getAllData();
  }
};
</script>
<style>
.verification-summary {
  margin-top: 10px;
  font-size: 0.9rem;
}
.verification-summary__bad {
  color: #f56c6c;
}
.verification-summary__ok {
  color: rgb(100, 200, 28);
}
.verification-summary__meta {
  color: #909399;
  margin-left: 10px;
}
/* .el-table .new-row {
  animation-duration: 1s;
  animation-name: blinknewrow;
  animation-iteration-count: 1;
}
@keyframes blinknewrow {
  from {
    background-color: transparent;
  }
  50% {
    background-color: pink;
  }
  to {
    background-color: transparent;
  }
} */
</style>



// WEBPACK FOOTER //
// src/components/pages/Ledger/components/Balances/balances.vue